import { Item } from '@models/item.interface';

export const itemsDemo: Item[] = [
  {
    name: 'Strange Professional Killstreak Fists of Steel',
    price: 4.24,
    image: 'https://steamcommunity-a.akamaihd.net/economy/image/6TMcQ7eX6E0EZl2byXi7vaVKyDk_zQLX05x6eLCFM9neAckxGDf7qU2e2gu64OnAeQ7835Ze4mLFfDY0jhyo8DEiv5daPaw7q7w_Qfi5ukX2eK4',
    color: '#ff0000',
    assetid: '1',
    type: 1,
  },
  {
    name: 'The Dogfighter',
    price: 0.33,
    image: 'https://steamcommunity-a.akamaihd.net/economy/image/6TMcQ7eX6E0EZl2byXi7vaVKyDk_zQLX05x6eLCFM9neAckxGDf7qU2e2gu64OnAeQ7835Ze4mLFfDY0jhyo8DEiv5daPaw7q7w_Qfi5ukX2eK4',
    color: '#7D6D00',
    type: 'Level 75 Coat',
    assetid: '2',
  },
  {
    name: 'The Bone Cone',
    price: 0.5,
    image: 'https://steamcommunity-a.akamaihd.net/economy/image/6TMcQ7eX6E0EZl2byXi7vaVKyDk_zQLX05x6eLCFM9neAckxGDf7qU2e2gu64OnAeQ7835Ze4mLFfDY0jhyo8DEiv5daPaw7q7w_Qfi5ukX2eK4',
    color: '#7D6D00',
    type: 'Level 75 Hat',
    assetid: '3',
  },
  {
    name: 'Mann Co. Supply Crate Key',
    price: 2.5,
    image: 'https://steamcommunity-a.akamaihd.net/economy/image/6TMcQ7eX6E0EZl2byXi7vaVKyDk_zQLX05x6eLCFM9neAckxGDf7qU2e2gu64OnAeQ7835Ze4mLFfDY0jhyo8DEiv5daPaw7q7w_Qfi5ukX2eK4',
    color: '#7D6D00',
    type: 'Level 5 Tool',
    assetid: '4',
  },
];
